import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../popup/modal-layout";
import XCloseIcon from "../../icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../context/Context";
import { useApiCall } from "../../custom-hooks/api-call";
import Tooltip from "../../ui/tooltip";
import { Loader2, Trash2, Check } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
  SelectSearch,
} from "../../form/form-layout";
import InnerLoader from "../../ui/loader/inner-loader";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");
const htmlToText = (html = "") => {
  return html
    .replace(/\t/g, "") // remove tabs
    .replace(/\r/g, "") // remove carriage returns
    .replace(/<\/li>/gi, "\n") // li end → newline
    .replace(/<br\s*\/?>/gi, "\n") // br → newline
    .replace(/<[^>]*>/g, "") // remove all other HTML tags
    .replace(/&amp;/g, "&") // decode &amp;
    .replace(/\n\s*\n+/g, "\n") // remove multiple empty lines
    .trim(); // trim start/end
};

const EditDealModal = ({
  onSubmit = () => { },
  onClose = () => { },
  onError = () => { },
  dealData = null,
  type = "",
  DealStages = [],
  // ClientList = [],
  // page = 1,
  // onLoadMoreClients,
  // hasMoreClients,
  // isLoadingClients,
  contactId,
  onDealUpdated,
  Style,
}) => {
  const [apiDealData, setApiDealData] = useState({});

  useEffect(() => {
    if (dealData?.dealid) {
      getDealData(dealData);
    }
  }, []);

  const [updateLoading, setUpdateLoading] = useState(false);
  const getDealData = async (dealData) => {
    setUpdateLoading(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `deals/get-deal/${dealData?.dealid}`,
      });

      console.log("apiDealData", res?.data);
      setApiDealData(res?.data);
    } catch (error) {
    } finally {
      setUpdateLoading(false);
    }
  };

  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const isWon = apiDealData?.current_stage?.dealstatus === "Won";
  const isLost = apiDealData?.current_stage?.dealstatus === "Lost";
  const activeColor = isWon ? "#22c55e" : isLost ? "#ef4444" : "#2563eb";

  const [searchClient, setSearchClient] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [CurrentStage, setCurrentStage] = useState(null);
  const [mainProducts, setMainProducts] = useState([]);
  const [subProducts, setSubProducts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [loadingMain, setLoadingMain] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);
  const [loadingPackages, setLoadingPackages] = useState(false);
  const [hasMoreClients, setHasMoreClients] = useState(true);
  const [isLoadingClients, setIsLoadingClients] = useState(false);
  const [Clients, setClients] = useState([]); // use only in deal
  const [page, setPage] = useState(1);

  const [selectedClient, setSelectedClient] = useState(null);

  const loadClients = async (pageNum = 1, search = "") => {
    // agar search active hai to hamesha page 1 hi chalega
    if (search && pageNum > 1) return;

    if (isLoadingClients || (!hasMoreClients && pageNum !== 1)) return;

    if (pageNum === 1) {
      setHasMoreClients(true);
      setPage(1);
    }

    setIsLoadingClients(true);

    try {
      const url = search
        ? `users/customers-list?search=${encodeURIComponent(search)}`
        : `users/customers-list?page=${pageNum}`;

      const res = await apiCall({ method: "get", url });
      const newClients = res?.customers || [];

      if (pageNum === 1) {
        setClients(newClients);
      } else if (newClients.length === 0) {
        setHasMoreClients(false);
      } else {
        setClients((prev) => [...prev, ...newClients]);
      }

      setPage(pageNum);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setIsLoadingClients(false);
    }
  };

  useEffect(() => {
    loadClients();
  }, []);

  useEffect(() => {
    if (formik.values.contactid && Clients.length) {
      const found = Clients.find(
        (c) => c.userid === formik.values.contactid
      );

      if (found) {
        setSelectedClient({
          value: found.userid,
          label: found.name || "Unnamed",
        });
      }
    }
  }, [Clients]);

  const metas = React.useMemo(() => {
    return Object.fromEntries(
      apiDealData?.metas?.map((m) => [m.meta_key, m.meta_value]) ?? [],
    );
  }, [apiDealData]);

  const initialMainId = metas?.main_product ? Number(metas.main_product) : null;
  // const initialMainId = apiDealData?.deal_product ? Number(apiDealData.deal_product) : null;
  const initialSubId = apiDealData?.deal_product
    ? Number(apiDealData.deal_product)
    : null;
  const initialPackageId = apiDealData?.deal_package
    ? Number(metas?.deal_package)
    : null;

  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    if (
      !dealData?.contactid ||
      // dealData?.deal_type !== "account" ||
      type !== "account"
    ) {
      return;
    }

    const fetchProjects = async () => {
      try {
        const res = await apiCall({
          method: "get",
          url: `projects/get-client-projects-list/${dealData?.contactid}`,
        });
        setProjectList(res?.data || []);
      } catch (error) {
        console.error("Error fetching client projects:", error);
      }
    };

    fetchProjects();
  }, [dealData?.contactid]);

  // console.log("apiDealData", apiDealData)

  useEffect(() => {
    // const metaArray = Array.isArray(apiDealData?.extra_meta)
    //   ? apiDealData?.extra_meta
    //   : Array.isArray(apiDealData?.meta)
    //     ? apiDealData.meta
    //     : Array.isArray(apiDealData?.metas)
    //       ? apiDealData?.metas
    //       : [];
    // console.log("metas", metas);
    // console.log("metaArray", metaArray);

    // setExtraMeta(metaArray);

    if (apiDealData?.metas?.length) {
      const isAddonMeta = apiDealData?.metas.find(
        (m) => m.meta_key === "is_addon",
      );
      const projectMeta = apiDealData?.metas.find(
        (m) => m.meta_key === "projectid",
      );

      formik.setFieldValue("attachProject", isAddonMeta?.meta_value === "1");
      formik.setFieldValue(
        "projectId",
        projectMeta?.meta_value ? Number(projectMeta.meta_value) : "",
      );
    }
  }, [apiDealData]);

  useEffect(() => {
    if (apiDealData?.current_stage && DealStages?.length > 0) {
      const stage = DealStages.find(
        (s) => s.name === apiDealData.current_stage?.dealstatus ?? "-",
      );
      setCurrentStage(stage?.id || DealStages[0]?.id);
    } else {
      setCurrentStage(DealStages[0]?.id || null); // fallback
    }
  }, [apiDealData, DealStages]);

  // const [extraMeta, setExtraMeta] = useState(
  // apiDealData?.metas
  //   ? apiDealData.metas
  //       .filter(
  //         (m) =>
  //           ![
  //             "features",
  //             "deal_product",
  //             "contactid",
  //             "dealstage",
  //             "deal_package",
  //             "estimated_payment_date",
  //             "dealamount",
  //             "dealprobability",
  //             "description",
  //             "dealpackage",
  //             "dealkey",
  //             "packageCat",
  //             "packagename",
  //             "name",
  //             "group_id",
  //             "dealtype",
  //             "main_product",
  //           ].includes(m.meta_key),
  //       )
  //       .map((m) => ({ key: m.meta_key, value: m.meta_value }))
  //   : [],
  // );
  const [extraMeta, setExtraMeta] = useState([]);
  useEffect(() => {
    if (!Array.isArray(apiDealData?.metas)) {
      setExtraMeta([]);
      return;
    }

    const filtered = apiDealData.metas
      .filter(
        (m) =>
          ![
            "features",
            "deal_product",
            "contactid",
            "dealstage",
            "deal_package",
            "estimated_payment_date",
            "dealamount",
            "dealprobability",
            "description",
            "dealpackage",
            "dealkey",
            "packageCat",
            "packagename",
            "name",
            "group_id",
            "dealtype",
            "main_product",
          ].includes(m.meta_key),
      )
      .map((m) => ({
        key: m.meta_key,
        value: m.meta_value,
      }));

    setExtraMeta(filtered);
  }, [apiDealData]);

  useEffect(() => {
    console.log("contactId", contactId);

    loadMainProducts();
  }, []);

  useEffect(() => {
    if (initialMainId) {
      loadSubProducts(initialMainId).then(() => {
        if (initialSubId) {
          loadPackages(initialSubId);
        }
      });
    } else if (initialSubId) {
      loadPackages(initialSubId);
    }
  }, [initialMainId, initialSubId]);

  const validationSchema = yup.object({
    name: yup.string().required("This Field is Required"),
    main_product: yup.string().required("This Field is Required"),
    deal_product: yup.string().when("main_product", {
      is: (val) => Number(val) !== 9,
      then: (schema) => schema.required("This Field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    deal_package_id: yup.string().required("This Field is Required"),
    estimated_payment_date: yup.string().required("This Field is Required"),
    dealamount: yup.number().required("This Field is Required"),
    dealprobability: yup.string().required("This Field is Required"),
    description: yup.string().required("This Field is Required"),

    // new conditional validation
    projectId: yup.string().when("attachProject", {
      is: true,
      then: (schema) => schema.required("This Field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      contactid: contactId ?? apiDealData?.contactid ?? "",

      main_product: initialMainId || "",

      deal_product: apiDealData?.deal_product
        ? Number(apiDealData.deal_product)
        : "",

      deal_package_id: apiDealData?.deal_package
        ? Number(apiDealData.deal_package)
        : "",
      deal_package: apiDealData?.metas?.packagename || "",
      features: metas?.features || "",
      estimated_payment_date: metas?.estimated_payment_date || "",
      dealamount: metas?.dealamount || "",
      dealstage: apiDealData?.dealstage || DealStages[0]?.name || "",
      dealprobability: Number(metas?.dealprobability) || "",
      description: metas?.description || "",
      name: apiDealData?.name || "",
      attachProject: false, // new
      projectId: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const combinedExtraMeta = [
        { key: "features", value: values.features },
        { key: "main_product", value: String(values.main_product) }, // save as string like other metas
        ...extraMeta.filter((f) => f.key && f.value),
        { key: "is_addon", value: values.attachProject ? "1" : "0" },
        { key: "projectid", value: values.projectId || "" },
      ];

      const data = {
        contactid: values.contactid,
        name: values.name,
        deal_product:
          values.main_product !== 9 ? Number(values.deal_product) : 9,
        deal_package: Number(values.deal_package_id) || null,
        estimated_payment_date: values.estimated_payment_date,
        dealamount: values.dealamount,
        dealstage: values.dealstage?.toLowerCase().replace(/\s+/g, "_") || "",
        dealprobability: Number(values.dealprobability),
        description: values.description,
        extra_meta: combinedExtraMeta,
      };

      // console.log("data", data);

      try {
        const url = apiDealData?.dealid
          ? `deals/update-deal/${apiDealData?.dealid}`
          : "deals/add-deal";

        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });

        if (onDealUpdated) onDealUpdated();
        if (onSubmit) onSubmit(apiRes?.message || "Deal saved successfully");

        formik.resetForm();
        onClose();
      } catch (error) {
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response?.data?.respMsg ||
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong",
        );
      }
    },
  });

  useEffect(() => {
    const textarea = document.querySelector("textarea[name='features']");
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [formik.values.features]);

  const loadMainProducts = async () => {
    setLoadingMain(true);
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });
      setMainProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading main products:", err);
    } finally {
      setLoadingMain(false);
    }
  };

  const loadSubProducts = async (mainId) => {
    if (!mainId) {
      setSubProducts([]);
      return;
    }
    setLoadingSub(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-products/${mainId}`,
      });
      setSubProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading sub-products:", err);
      setSubProducts([]);
    } finally {
      setLoadingSub(false);
    }
  };

  const loadPackages = async (subProductId) => {
    if (!subProductId) {
      setPackages([]);
      return;
    }
    setLoadingPackages(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-product-packages/${subProductId}`,
      });
      setPackages(res?.data || []);
    } catch (err) {
      console.warn("Error loading packages:", err);
      setPackages([]);
    } finally {
      setLoadingPackages(false);
    }
  };

  // Handlers for selects
  const handleMainSelect = async (option) => {
    console.log("Option Main", option);

    const id = option || "";

    formik.setFieldValue("main_product", id);

    formik.setFieldValue("deal_product", "");
    formik.setFieldValue("deal_package_id", "");
    formik.setFieldValue("deal_package", "");
    formik.setFieldValue("features", "");
    setSubProducts([]);
    setPackages([]);

    if (id) {
      id == 9 ? await loadPackages(id) : await loadSubProducts(id);
    }
  };

  const handleSubSelect = async (option) => {
    const id = option || "";
    formik.setFieldValue("deal_product", id);

    formik.setFieldValue("deal_package_id", "");
    formik.setFieldValue("deal_package", "");
    formik.setFieldValue("features", "");
    setPackages([]);

    if (id) {
      await loadPackages(id);
    }
  };

  const handlePackageSelect = (option) => {
    const id = option || "";
    const pkg = packages.find((p) => Number(p.packageid) === Number(id));
    formik.setFieldValue("deal_package_id", id);
    formik.setFieldValue("deal_package", pkg?.packagename || "");
    // set features from package if exists
    if (pkg?.features) {
      formik.setFieldValue("features", htmlToText(pkg.features || ""));
    } else {
      // 👇 clear the textbox if "Add Other" or no features exist
      formik.setFieldValue("features", "");
    }
  };

  const [TotalStages, setTotalStages] = useState(5);

  useEffect(() => {
    let totalStages = DealStages?.length;
    setTotalStages(totalStages);
  }, [DealStages]);

  const handleStageClick = (stageId) => {
    setCurrentStage(stageId);
    const stage = DealStages.find((s) => s.id === stageId);
    const formattedName = stage?.name?.toLowerCase().replace(/\s+/g, "_") || "";
    formik.setFieldValue("dealstage", formattedName);
  };

  const subProductsUnique = subProducts.filter(
    (v, i, a) =>
      a.findIndex(
        (t) =>
          Number(t.id ?? t.subproductid ?? t.productid) ===
          Number(v.id ?? v.subproductid ?? v.productid),
      ) === i,
  );
  const packagesUnique = packages.filter(
    (v, i, a) =>
      a.findIndex((t) => Number(t.packageid) === Number(v.packageid)) === i,
  );

  const mainOptions = mainProducts.map((mp) => ({
    value: mp.id ?? mp.productid ?? mp.main_product_id ?? mp.id,
    label: mp.products || mp.name || mp.title || `#${mp.id}`,
  }));
  const subOptions = subProductsUnique.map((sp) => ({
    value: sp.id ?? sp.subproductid ?? sp.productid,
    label: sp.products || sp.name || sp.title || `#${sp.id}`,
  }));
  const packageOptions =
    packagesUnique.length > 0
      ? [
        ...packagesUnique.map((pk) => ({
          value: pk.packageid,
          label: pk.packagename || `#${pk.packageid}`,
        })),
        { value: 3, label: "Add Other" },
      ]
      : [];

  const editMainId = metas?.main_product ? Number(metas.main_product) : null;
  const editSubId = apiDealData?.deal_product
    ? Number(apiDealData.deal_product)
    : null;
  const editPackageId = apiDealData?.deal_package
    ? Number(apiDealData.deal_package)
    : null;

  useEffect(() => {
    let mounted = true;
    const runPrefill = async () => {
      try {
        if (editMainId) {
          formik.setFieldValue("main_product", editMainId, false);

          await loadSubProducts(editMainId);
        }

        if (editSubId) {
          const existsInSub = subProducts.some(
            (sp) =>
              Number(sp.id ?? sp.subproductid ?? sp.productid) ===
              Number(editSubId),
          );
          if (!existsInSub) {
            setSubProducts((prev) => {
              const merged = [
                ...prev,
                {
                  id: editSubId,
                  products:
                    apiDealData?.deal_product_name || `Product #${editSubId}`,
                },
              ];
              // ✅ remove duplicates by id/subproductid/productid
              const unique = merged.filter(
                (v, i, a) =>
                  a.findIndex(
                    (t) =>
                      Number(t.id ?? t.subproductid ?? t.productid) ===
                      Number(v.id ?? v.subproductid ?? v.productid),
                  ) === i,
              );
              return unique;
            });
          }

          formik.setFieldValue("deal_product", editSubId, false);

          await loadPackages(editSubId);

          if (editPackageId) {
            const existsPkg = packages.some(
              (pk) => Number(pk.packageid) === Number(editPackageId),
            );
            if (!existsPkg) {
              setPackages((prev) => {
                const merged = [
                  ...prev,
                  {
                    packageid: editPackageId,
                    packagename: metas?.packagename,
                  },
                ];
                // ✅ remove duplicates by packageid
                const unique = merged.filter(
                  (v, i, a) =>
                    a.findIndex(
                      (t) => Number(t.packageid) === Number(v.packageid),
                    ) === i,
                );
                return unique;
              });
            }

            formik.setFieldValue("deal_package_id", editPackageId, false);

            formik.setFieldValue(
              "deal_package",
              apiDealData?.deal_package || metas?.deal_package_name || "",
              false,
            );
          }
        } else if (!editSubId && editPackageId) {
          const existsPkg = packages.some(
            (pk) => Number(pk.packageid) === Number(editPackageId),
          );
          if (!existsPkg) {
            setPackages((prev) => {
              const merged = [
                ...prev,
                {
                  packageid: editPackageId,
                  packagename: metas?.packagename,
                },
              ];
              // ✅ remove duplicates by packageid
              const unique = merged.filter(
                (v, i, a) =>
                  a.findIndex(
                    (t) => Number(t.packageid) === Number(v.packageid),
                  ) === i,
              );
              return unique;
            });
          }
          formik.setFieldValue("deal_package_id", editPackageId, false);
        }
      } catch (err) { }
    };

    if (apiDealData) {
      runPrefill();
    }

    return () => {
      mounted = false;
    };
  }, [apiDealData]);

  const selectedMainOption =
    mainOptions.find(
      (o) => Number(o.value) === Number(formik.values.main_product),
    ) || null;
  const selectedSubOption =
    subOptions.find(
      (o) => Number(o.value) === Number(formik.values.deal_product),
    ) || null;
  const selectedPackageOption =
    packageOptions.find(
      (o) => Number(o.value) === Number(formik.values.deal_package_id),
    ) || null;

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {updateLoading ? (
          <div className="flex justify-center items-center h-full">
            <InnerLoader />
          </div>
        ) : (
          <>
            {/* Body */}
            <div className={Style.modal_body}>
              <FormArea>
                {/* clients */}

                {(!apiDealData?.contactid && !contactId) && (
                  <FeildWraper width="100%">
                    <FormLabel required>Client Name</FormLabel>
                    <Select
                      name="contactid"
                      classNamePrefix="react-select"
                      className="text-sm"
                      placeholder="Search customer..."
                      value={selectedClient}
                      onChange={(option) => {
                        setSelectedClient(option);
                        formik.setFieldValue("contactid", option?.value || "");
                      }}
                      options={Clients.map((c) => ({
                        value: c.userid,
                        label: c.name || "Unnamed",
                      }))}
                      components={{
                        IndicatorSeparator: () => null,
                        LoadingIndicator: () => (
                          <div className="flex items-center pr-2">
                            <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />
                          </div>
                        ),
                      }}
                      isClearable
                      isLoading={isLoadingClients}
                      onInputChange={(value, action) => {
                        if (action.action === "input-change") {
                          setSearchClient(value);
                          if (searchTimeout) clearTimeout(searchTimeout);

                          if (value.length >= 3) {
                            const timeout = setTimeout(() => {
                              // onLoadMoreClients(1, value.trim());
                              loadClients(1, value.trim());
                            }, 400);
                            setSearchTimeout(timeout);
                          } else if (value.length === 0) {
                            const timeout = setTimeout(() => {
                              // onLoadMoreClients(1, "");
                              loadClients(1, "");
                            }, 300);
                            setSearchTimeout(timeout);
                          }
                        }
                      }}
                      onMenuOpen={() => {
                        if (Clients?.length === 0 && !isLoadingClients) {
                          // onLoadMoreClients(1, "");
                          loadClients(1, "");
                        }
                      }}
                      onMenuClose={() => {
                        if (searchClient.length > 0) {
                          setSearchClient("");
                          // onLoadMoreClients(1, "");
                          loadClients(1, "");
                        }
                      }}
                      onMenuScrollToBottom={() => {
                        if (
                          !searchClient &&
                          hasMoreClients &&
                          !isLoadingClients
                        ) {
                          // onLoadMoreClients(page + 1, "");
                          loadClients(page + 1, "");
                        }
                      }}
                      menuPortalTarget={document.body}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: state.isFocused ? "#e5e7eb" : "#e5e7eb",
                          boxShadow: state.isFocused
                            ? "0 0 0 1px #e5e7eb"
                            : "none",
                          "&:hover": { borderColor: "#e5e7eb" },
                          borderRadius: "0.5rem",
                          minHeight: "40px",
                          fontSize: "0.875rem",
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 99999,
                          borderRadius: "0.5rem",
                          padding: "0.25rem 0",
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                        option: (base, { isFocused, isSelected }) => ({
                          ...base,
                          backgroundColor: isSelected
                            ? "#3b82f6"
                            : isFocused
                              ? "#eff6ff"
                              : "white",
                          color: isSelected ? "white" : "#111827",
                          cursor: "pointer",
                          fontSize: "0.875rem",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color: "#9ca3af",
                        }),
                      }}
                    />
                  </FeildWraper>
                )}

                {/* Main Product */}

                <FeildWraper width="100%">
                  <FormLabel required>Main Product</FormLabel>

                  <SelectSearch
                    name="main_product"
                    placeholder="- Select Product -"
                    onChange={handleMainSelect}
                    value={formik?.values.main_product}
                    options={mainOptions}
                    onBlur={() =>
                      formik.setFieldTouched("main_product", true, true)
                    }
                  // menuPosition="fixed"
                  />
                  {formik.touched.main_product &&
                    formik.errors.main_product && (
                      <FeildError>{formik.errors.main_product}</FeildError>
                    )}
                </FeildWraper>

                {/* Sub product */}
                {formik.values.main_product !== 9 ? (
                  <FeildWraper>
                    <FormLabel required>Sub Product</FormLabel>

                    <SelectSearch
                      name="deal_product"
                      placeholder={
                        formik.values.main_product
                          ? "- Select Sub Product -"
                          : "Please select a product first"
                      }
                      onChange={(val) => {
                        formik.setFieldValue("deal_product", val ? val : "");
                        handleSubSelect(val);
                      }}
                      isDisabled={!formik.values.main_product}
                      value={formik?.values.deal_product}
                      options={subOptions}
                      onBlur={() =>
                        formik.setFieldTouched("deal_product", true, true)
                      }
                    // menuPosition="fixed"
                    />
                    {formik.touched.deal_product &&
                      formik.errors.deal_product && (
                        <FeildError>{formik.errors.deal_product}</FeildError>
                      )}
                  </FeildWraper>
                ) : null}

                {/* Package */}

                <FeildWraper
                  width={formik.values.main_product == 9 ? `100%` : `50%`}
                >
                  <FormLabel required>Package</FormLabel>

                  <SelectSearch
                    name="deal_package_id"
                    placeholder={
                      formik.values.deal_product ||
                        formik.values.main_product == 9
                        ? "- Select Package -"
                        : "Please select a sub product first"
                    }
                    onChange={handlePackageSelect}
                    isDisabled={
                      !formik.values.deal_product &&
                      formik.values.main_product !== 9
                    }
                    value={formik.values.deal_package_id}
                    options={
                      formik.values.deal_product ||
                        formik.values.main_product == 9
                        ? packageOptions
                        : []
                    }
                    onBlur={() =>
                      formik.setFieldTouched("deal_package_id", true, true)
                    }
                  // menuPosition="fixed"
                  />

                  {formik.touched.deal_package_id &&
                    formik.errors.deal_package_id && (
                      <FeildError>{formik.errors.deal_package_id}</FeildError>
                    )}
                </FeildWraper>

                {dealData?.contactid &&
                  (dealData?.deal_type == "account" || type == "account") && (
                    <>
                      <div className="w-full px-4">
                        {/* <div className="flex flex-start  gap-2">
                    <input
                      id="isAddon"
                      type="checkbox"
                      checked={formik.values.attachProject || false}
                      onChange={(e) => {
                        formik.setFieldValue("attachProject", e.target.checked);
                        if (!e.target.checked) {
                          formik.setFieldValue("projectId", "");
                        }
                      }}
                      className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    />

                    <div>Is Addon</div>
                  </div> */}

                        <div className="flex items-center gap-3 group cursor-pointer select-none">
                          <div className="relative">
                            <input
                              id="isAddon"
                              type="checkbox"
                              checked={formik.values.attachProject || false}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "attachProject",
                                  e.target.checked,
                                );
                                if (!e.target.checked) {
                                  formik.setFieldValue("projectId", "");
                                }
                              }}
                              className="peer h-5 w-5 appearance-none rounded-md border border-gray-300
                 checked:bg-blue-600 checked:border-blue-600
                 focus:outline-none focus:ring-2 focus:ring-blue-500
                 transition-all duration-200 cursor-pointer"
                            />

                            {/* Lucide Check Icon */}
                            <Check
                              size={14}
                              strokeWidth={3}
                              className="absolute top-[3px] left-[3px] text-white 
                 opacity-0 peer-checked:opacity-100 
                 transition-opacity duration-200 pointer-events-none"
                            />
                          </div>

                          <label
                            htmlFor="isAddon"
                            className="text-sm font-medium text-gray-700 
               group-hover:text-blue-600 
               transition-colors duration-200 cursor-pointer"
                          >
                            Is Addon
                          </label>
                        </div>
                      </div>

                      {/* Project Dropdown */}
                      {formik.values.attachProject && (
                        <FeildWraper width="100%">
                          <FormLabel>Select Project</FormLabel>

                          <SelectSearch
                            name="projectId"
                            placeholder={"- Select Project -"}
                            onChange={(val) => {
                              formik?.setFieldValue("projectId", val);
                            }}
                            value={formik.values.projectId}
                            options={
                              projectList?.map((p) => ({
                                value: p.projectid,
                                label: p.invoiceid,
                              })) || []
                            }
                            onBlur={() =>
                              formik.setFieldTouched("projectId", true, true)
                            }
                          // menuPosition="fixed"
                          />

                          {formik.touched.projectId &&
                            formik.errors.projectId && (
                              <FeildError>{formik.errors.projectId}</FeildError>
                            )}
                        </FeildWraper>
                      )}
                      {/* </div> */}
                    </>
                  )}

                {/* Deal name */}
                <FeildWraper>
                  <FormLabel required>Deal Name</FormLabel>
                  <input
                    type="text"
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Name"
                    disabled={!!apiDealData?.dealid}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <FeildError>{formik.errors.name}</FeildError>
                  )}
                </FeildWraper>

                {/* date */}
                <FeildWraper>
                  <FormLabel required>Amount</FormLabel>
                  <input
                    type="number"
                    name="dealamount"
                    min="0"
                    value={formik.values.dealamount}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.dealamount && formik.errors.dealamount && (
                    <FeildError>{formik.errors.dealamount}</FeildError>
                  )}
                </FeildWraper>

                {/* amount */}
                <FeildWraper>
                  <FormLabel required>Estimated Date</FormLabel>
                  <input
                    type="date"
                    name="estimated_payment_date"
                    min={new Date().toISOString().split("T")[0]}
                    value={formik.values.estimated_payment_date}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.estimated_payment_date &&
                    formik.errors.estimated_payment_date && (
                      <FeildError>
                        {formik.errors.estimated_payment_date}
                      </FeildError>
                    )}
                </FeildWraper>

                {/* Pipeline stage */}
                <FeildWraper className="!max-w-md">
                  <FormLabel>Pipeline stage</FormLabel>
                  <div className="flex  overflow-hidden h-8">
                    {DealStages.map((stage, index) => {
                      // const isActive = index === CurrentStage;
                      const isFirst = index === 0;
                      const isLast = index === TotalStages - 1;

                      //  Set clip-path based on position
                      let clipPath = "";
                      if (isFirst) {
                        clipPath = `
                                  polygon(
                                    0 0,
                                    calc(100% - 10px) 0,
                                    100% 50%,
                                    calc(100% - 10px) 100%,
                                    0 100%
                                  )
                                    
                                `;
                      } else if (isLast) {
                        clipPath = `
                                polygon(
                                  0 0,
                                  10px 50%,
                                  0 100%,
                                  100% 100%,
                                  100% 0
                                )
                              `;
                      } else {
                        clipPath = `
                                  polygon(
                                    0 0,
                                    10px 50%,
                                    0 100%,
                                    calc(100% - 10px) 100%,
                                    100% 50%,
                                    calc(100% - 10px) 0
                                  )
                                `;
                      }

                      return (
                        <Tooltip
                          key={`${index}-asideBottomItems`}
                          className={`${Style.Tooltip} `}
                          boxClassName={`${Style.TooltipBox} !z-[99999999]`}
                          content={stage?.name}
                          position={"bottom center"}
                        >
                          <div
                            key={index}
                            onClick={() => {
                              handleStageClick(stage.id);
                            }}
                            className={`
                                        min-h-[27px] min-w-[60px]  flex-1 
                                      ${stage.id <= CurrentStage
                                ? "bg-[#2563eb]"
                                : "bg-gray-200"
                              }
                                      ${isFirst
                                ? `rounded-tl-md rounded-bl-md`
                                : isLast
                                  ? "rounded-tr-md rounded-br-md"
                                  : null
                              }
                                    `}
                            style={{
                              clipPath: clipPath,
                              WebkitClipPath: clipPath,
                            }}
                          />
                        </Tooltip>
                      );
                    })}
                  </div>
                </FeildWraper>

                {/* probability */}
                <FeildWraper>
                  <FormLabel required>Deal Probability</FormLabel>
                  <SelectSearch
                    name="dealprobability"
                    placeholder="- Select Probability -"
                    onChange={(val) => {
                      formik.setFieldValue("dealprobability", val);
                    }}
                    value={formik.values.dealprobability}
                    onBlur={() =>
                      formik.setFieldTouched("dealprobability", true, true)
                    }
                    options={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(
                      (ele) => ({
                        label: ele,
                        value: ele,
                      }),
                    )}
                  />
                  {formik.touched.dealprobability &&
                    formik.errors.dealprobability && (
                      <FeildError>{formik.errors.dealprobability}</FeildError>
                    )}
                </FeildWraper>

                {/* description */}
                <FeildWraper>
                  <FormLabel required>Description</FormLabel>
                  <input
                    type="text"
                    name="description"
                    value={formik.values.description}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.description && formik.errors.description && (
                    <FeildError>{formik.errors.description}</FeildError>
                  )}
                </FeildWraper>

                {/* Features */}
                <FeildWraper width="100%">
                  <FormLabel>Features</FormLabel>
                  <textarea
                    name="features"
                    value={formik.values.features}
                    onChange={formik.handleChange}
                    rows={6}
                    placeholder="Write or edit package features here..."
                    className="max-h-96 min-h-40"
                  />

                  <FormLineBreak />
                </FeildWraper>

                {/* === T-shaped divider === */}
                {extraMeta?.length > 0 && (
                  <div className={Style.tDividerWrapper}>
                    <div className={Style.horizontalLine} aria-hidden="true" />
                    <div className={` ${Style.dividerLabel} px-2`}>
                      Additional Fields
                    </div>
                  </div>
                )}

                <FeildWraper width="100%">
                  {extraMeta?.map((field, index) => (
                    <div className={`w-full flex gap-3`} key={index}>
                      {/* key */}

                      <input
                        type="text"
                        placeholder="Meta key"
                        value={field.key}
                        onChange={(e) => {
                          const updated = [...extraMeta];
                          updated[index].key = e.target.value;
                          setExtraMeta(updated);
                        }}
                        className={Style.metaInput}
                      />

                      {/* value */}
                      <input
                        type="text"
                        placeholder="Meta value"
                        value={field.value}
                        onChange={(e) => {
                          const updated = [...extraMeta];
                          updated[index].value = e.target.value;
                          setExtraMeta(updated);
                        }}
                        className={Style.metaInput}
                      />

                      <Tooltip
                        key={`${index}-asideBottomItems`}
                        className={`${Style.Tooltip}`}
                        boxClassName={Style.TooltipBox}
                        content="Delete Field"
                        position={"bottom center"}
                      >
                        <div
                          onClick={() =>
                            setExtraMeta(
                              extraMeta.filter((_, i) => i !== index),
                            )
                          }
                          className="p-3 text-red-600"
                        >
                          <Trash2 size={18} />
                        </div>
                      </Tooltip>
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={() =>
                      setExtraMeta([...extraMeta, { key: "", value: "" }])
                    }
                    className="flex flex-start text-blue-700 font-medium   w-full p-2 text-[16px]"
                  >
                    + Add Field
                  </button>
                </FeildWraper>
              </FormArea>
            </div>
          </>
        )}

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {dealData?.dealid ? "Save Changes" : "Create Deal"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditDealModal;
